import { render, staticRenderFns } from "./review.vue?vue&type=template&id=2204266d&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"
import style0 from "./review.vue?vue&type=style&index=0&id=2204266d&prod&lang=less&scoped=true"
import style1 from "./review.vue?vue&type=style&index=1&id=2204266d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2204266d",
  null
  
)

export default component.exports